import { Helpers } from '../../helpers';
import { IAssetTeam } from '../../interfaces/iasset-team';
import { Area } from '../area';
import { AreaFactor } from '../area-factor';
import { AreaTargetFormationFactor } from '../area-target-formation-factor';
import { Asset } from '../asset';
import { CompletionDesign } from '../completion-design';
import { DefaultProjectTeam } from '../default-project-team';
import { Division } from '../division';
import { DrillDesign } from '../drill-design';
import { DrillDesignFactor } from '../drill-design-factor';
import { DrillDurationLookup } from '../drill-duration-lookup';
import { EffectivePercentAttainment } from '../effective-percent-attainment';
import { LateralLengthFactor } from '../lateral-length-factor';
import { Pad } from '../pad';
import { Pond } from '../pond';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';
import { Rig } from '../rig';
import { RotarySteerableFactor } from '../rotary-steerable-factor';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { Scenario } from '../scenario';
import { ScenarioDetail } from '../scenario-detail';
import { Setting } from '../setting';
import { StandardConfigurationAssetTeam } from '../standard-configuration-asset-team';
import { StandardRatesOfPenetration } from '../standard-rates-of-penetration';
import { TankBattery } from '../tank-battery';
import { TargetFormation } from '../target-formation';
import { TeamDevelopmentArea } from '../team-development-area';
import { TypeCurve } from '../type-curve';
import { WaterDisposalSystem } from '../water-disposal-system';
import { WaterWell } from '../water-well';

export class AssetTeamBase {
  AssetTeamId: number;
  NonStandardAssetTeamCode: string;
  AssetTeamCode: string;
  Name: string | null;
  SortOrder: number | null;
  Legacy: boolean;
  RigDepotLocation: object | null;
  Description: string | null;
  Shape: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SsnPrefix: string | null;

  AreaFactors_AssetTeam?: Array<AreaFactor> | null;
  Areas_AssetTeam?: Array<Area> | null;
  AreaTargetFormationFactors_AssetTeam?: Array<AreaTargetFormationFactor> | null;
  Assets_AssetTeam?: Array<Asset> | null;
  CompletionDesigns_AssetTeam?: Array<CompletionDesign> | null;
  DefaultProjectTeams_AssetTeam?: Array<DefaultProjectTeam> | null;
  Divisions_AssetTeam?: Array<Division> | null;
  DrillDesignFactors_AssetTeam?: Array<DrillDesignFactor> | null;
  DrillDesigns_AssetTeam?: Array<DrillDesign> | null;
  DrillDurationLookups_AssetTeam?: Array<DrillDurationLookup> | null;
  EffectivePercentAttainments_AssetTeam?: Array<EffectivePercentAttainment> | null;
  LateralLengthFactors_AssetTeam?: Array<LateralLengthFactor> | null;
  Pads_AssetTeam?: Array<Pad> | null;
  Ponds_AssetTeam?: Array<Pond> | null;
  Projects_AssetTeam?: Array<Project> | null;
  ProjectTemplates_AssetTeam?: Array<ProjectTemplate> | null;
  Rigs_AssetTeam?: Array<Rig> | null;
  RotarySteerableFactors_AssetTeam?: Array<RotarySteerableFactor> | null;
  SaltWaterDisposalFacilities_AssetTeam?: Array<SaltWaterDisposalFacility> | null;
  ScenarioDetails_AssetTeam?: Array<ScenarioDetail> | null;
  Scenarios_AssetTeam?: Array<Scenario> | null;
  Settings_AssetTeam?: Array<Setting> | null;
  StandardConfigurationAssetTeams_AssetTeam?: Array<StandardConfigurationAssetTeam> | null;
  StandardRatesOfPenetrations_AssetTeam?: Array<StandardRatesOfPenetration> | null;
  TankBatteries_AssetTeam?: Array<TankBattery> | null;
  TargetFormations_AssetTeam?: Array<TargetFormation> | null;
  TeamDevelopmentAreas_AssetTeam?: Array<TeamDevelopmentArea> | null;
  TypeCurves_AssetTeam?: Array<TypeCurve> | null;
  WaterDisposalSystems_AssetTeam?: Array<WaterDisposalSystem> | null;
  WaterWells_AssetTeam?: Array<WaterWell> | null;
  Pads_LegacyAssetTeam?: Array<Pad> | null;
  SaltWaterDisposalFacilities_LegacyAssetTeam?: Array<SaltWaterDisposalFacility> | null;
  TankBatteries_LegacyAssetTeam?: Array<TankBattery> | null;

  constructor(item?: IAssetTeam) {
    if (item) {

      this.AssetTeamId = item.AssetTeamId;
      this.NonStandardAssetTeamCode = item.NonStandardAssetTeamCode;
      this.AssetTeamCode = item.AssetTeamCode;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Legacy = item.Legacy;
      this.RigDepotLocation = item.RigDepotLocation;
      this.Description = item.Description;
      this.Shape = item.Shape;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SsnPrefix = item.SsnPrefix;

      this.AreaFactors_AssetTeam = Helpers.createClassArray(AreaFactor, item.AreaFactors_AssetTeam);
      this.Areas_AssetTeam = Helpers.createClassArray(Area, item.Areas_AssetTeam);
      this.AreaTargetFormationFactors_AssetTeam = Helpers.createClassArray(AreaTargetFormationFactor, item.AreaTargetFormationFactors_AssetTeam);
      this.Assets_AssetTeam = Helpers.createClassArray(Asset, item.Assets_AssetTeam);
      this.CompletionDesigns_AssetTeam = Helpers.createClassArray(CompletionDesign, item.CompletionDesigns_AssetTeam);
      this.DefaultProjectTeams_AssetTeam = Helpers.createClassArray(DefaultProjectTeam, item.DefaultProjectTeams_AssetTeam);
      this.Divisions_AssetTeam = Helpers.createClassArray(Division, item.Divisions_AssetTeam);
      this.DrillDesignFactors_AssetTeam = Helpers.createClassArray(DrillDesignFactor, item.DrillDesignFactors_AssetTeam);
      this.DrillDesigns_AssetTeam = Helpers.createClassArray(DrillDesign, item.DrillDesigns_AssetTeam);
      this.DrillDurationLookups_AssetTeam = Helpers.createClassArray(DrillDurationLookup, item.DrillDurationLookups_AssetTeam);
      this.EffectivePercentAttainments_AssetTeam = Helpers.createClassArray(EffectivePercentAttainment, item.EffectivePercentAttainments_AssetTeam);
      this.LateralLengthFactors_AssetTeam = Helpers.createClassArray(LateralLengthFactor, item.LateralLengthFactors_AssetTeam);
      this.Pads_AssetTeam = Helpers.createClassArray(Pad, item.Pads_AssetTeam);
      this.Ponds_AssetTeam = Helpers.createClassArray(Pond, item.Ponds_AssetTeam);
      this.Projects_AssetTeam = Helpers.createClassArray(Project, item.Projects_AssetTeam);
      this.ProjectTemplates_AssetTeam = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_AssetTeam);
      this.Rigs_AssetTeam = Helpers.createClassArray(Rig, item.Rigs_AssetTeam);
      this.RotarySteerableFactors_AssetTeam = Helpers.createClassArray(RotarySteerableFactor, item.RotarySteerableFactors_AssetTeam);
      this.SaltWaterDisposalFacilities_AssetTeam = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_AssetTeam);
      this.ScenarioDetails_AssetTeam = Helpers.createClassArray(ScenarioDetail, item.ScenarioDetails_AssetTeam);
      this.Scenarios_AssetTeam = Helpers.createClassArray(Scenario, item.Scenarios_AssetTeam);
      this.Settings_AssetTeam = Helpers.createClassArray(Setting, item.Settings_AssetTeam);
      this.StandardConfigurationAssetTeams_AssetTeam = Helpers.createClassArray(StandardConfigurationAssetTeam, item.StandardConfigurationAssetTeams_AssetTeam);
      this.StandardRatesOfPenetrations_AssetTeam = Helpers.createClassArray(StandardRatesOfPenetration, item.StandardRatesOfPenetrations_AssetTeam);
      this.TankBatteries_AssetTeam = Helpers.createClassArray(TankBattery, item.TankBatteries_AssetTeam);
      this.TargetFormations_AssetTeam = Helpers.createClassArray(TargetFormation, item.TargetFormations_AssetTeam);
      this.TeamDevelopmentAreas_AssetTeam = Helpers.createClassArray(TeamDevelopmentArea, item.TeamDevelopmentAreas_AssetTeam);
      this.TypeCurves_AssetTeam = Helpers.createClassArray(TypeCurve, item.TypeCurves_AssetTeam);
      this.WaterDisposalSystems_AssetTeam = Helpers.createClassArray(WaterDisposalSystem, item.WaterDisposalSystems_AssetTeam);
      this.WaterWells_AssetTeam = Helpers.createClassArray(WaterWell, item.WaterWells_AssetTeam);
      this.Pads_LegacyAssetTeam = Helpers.createClassArray(Pad, item.Pads_LegacyAssetTeam);
      this.SaltWaterDisposalFacilities_LegacyAssetTeam = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_LegacyAssetTeam);
      this.TankBatteries_LegacyAssetTeam = Helpers.createClassArray(TankBattery, item.TankBatteries_LegacyAssetTeam);
    }
  }
}